import {UfFlowService} from './service/api/uf-flow/uf-flow.service';
import {UfFlowTypeService} from './service/api/uf-flow-type/uf-flow-type.service';
import {UfFlowStepService} from './service/api/uf-flow-step/uf-flow-step.service';
import {UfFlowObjectService} from './service/api/uf-flow-object/uf-flow-object.service';
import {UfFlowTopicService} from './service/api/uf-flow-topic/uf-flow-topic.service';
import {UfFlowTypeStepService} from './service/api/uf-flow-type-step/uf-flow-type-step.service';
import {
    UfFlowTypeStepActivityService
} from './service/api/uf-flow-type-step-activity/uf-flow-type-step-activity.service';
import {UfFlowTypeStepActionService} from './service/api/uf-flow-type-step-action/uf-flow-type-step-action.service';
import {UfFlowTypeObjectRoleService} from './service/api/uf-flow-type-object-role/uf-flow-type-object-role.service';
import {UfFormTypeService} from './service/api/uf-form-type/uf-form-type.service';
import {UfFormTypeFieldService} from './service/api/uf-form-type-field/uf-form-type-field.service';
import {
    UfFormTypeObjectReferenceService
} from './service/api/uf-form-type-object-reference/uf-form-type-object-reference.service';
import {UfFormService} from './service/api/uf-form/uf-form.service';
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {UfFlowComponent} from './component/protected-components/uf-flow/uf-flow.component';
import {
    UfFormTypeObjectComponent
} from './component/object-components/uf-form-type-object-component/uf-form-type-object.component';
import {
    UfFormObjectComponent
} from './component/object-components/uf-form-object-component/uf-form-object.component';
import {
    UfFlowTypeObjectComponent
} from './component/object-components/uf-flow-type-object-component/uf-flow-type-object.component';
import {
    UfFlowTypeStepObjectComponent
} from './component/object-components/uf-flow-type-step-object-component/uf-flow-type-step-object.component';
import {
    UfFlowTypeStepActivityObjectComponent
} from './component/object-components/uf-flow-type-step-activity-object-component/uf-flow-type-step-activity-object.component';

export const UF_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['uf.UfFlow', {
                route: '/uf/flow/:id',
                service: UfFlowService,
                objectComponent: [{component: UfFlowComponent}]
            }],
            ['uf.UfFlowType', {
                route: '/uf/config',
                service: UfFlowTypeService,
                objectComponent: [{component: UfFlowTypeObjectComponent}]
            }],
            ['uf.UfFlowStep', {route: 'about:blank', service: UfFlowStepService}],
            ['uf.UfFlowObject', {route: 'about:blank', service: UfFlowObjectService}],
            ['uf.UfFlowTopic', {route: 'about:blank', service: UfFlowTopicService}],
            ['uf.UfFlowTypeStep', {
                route: 'about:blank',
                service: UfFlowTypeStepService,
                objectComponent: [{component: UfFlowTypeStepObjectComponent}]
            }],
            ['uf.UfFlowTypeStepActivity', {
                route: 'about:blank',
                service: UfFlowTypeStepActivityService,
                objectComponent: [{component: UfFlowTypeStepActivityObjectComponent}]
            }],
            ['uf.UfFlowTypeStepAction', {route: 'about:blank', service: UfFlowTypeStepActionService}],
            ['uf.UfFlowTypeObjectRole', {route: 'about:blank', service: UfFlowTypeObjectRoleService}],
            ['uf.UfFormType', {
                route: '/uf/formType/:id',
                service: UfFormTypeService,
                objectComponent: [{component: UfFormTypeObjectComponent}]
            }],
            ['uf.UfFormTypeField', {route: 'about:blank', service: UfFormTypeFieldService}],
            ['uf.UfFormTypeObjectReference', {route: 'about:blank', service: UfFormTypeObjectReferenceService}],
            ['uf.UfForm', {
                route: '/uf/form/:id',
                service: UfFormService,
                objectComponent: [{component: UfFormObjectComponent}]
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
